<nav class="navbar navbar-expand-xl navbar-dark bg-dark d-print-none">
  <div class="container-fluid">
    <a href="https://www.cronox.app" target="_blank">
      <img src="assets/images/logo.png" style="height: 3rem;" title="Cronox">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="offcanvas offcanvas-end" style="width: 20rem;" tabindex="-1" id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-body">
        <div class="navbar-collapse" id="navbar">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a title="Main" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
                routerLink="" data-bs-dismiss="offcanvas" i18n>Main</a>
            </li>
            <!--
            <li class="nav-item">
              <a title="Nuuduu Partners" class="nav-link" routerLinkActive="active" routerLink="employees"
                data-bs-dismiss="offcanvas" i18n>Nuuduu Partners</a>
            </li>
            -->
            <li class="nav-item">
              <a title="Products" class="nav-link" routerLinkActive="active" routerLink="campaigns"
                data-bs-dismiss="offcanvas" i18n>Order ads</a>
            </li>
            <li class="nav-item">
              <a title="Products" class="nav-link" routerLinkActive="active" routerLink="placements"
                data-bs-dismiss="offcanvas" i18n>Product placement</a>
            </li>
            <li class="nav-item">
              <a title="Settings" class="nav-link" routerLinkActive="active" routerLink="settings"
                data-bs-dismiss="offcanvas" i18n>Settings</a>
            </li>
            <!--
            <li *ngIf="currentUser.type != 'partner'" class="nav-item">
              <a title="Applicants" class="nav-link" routerLinkActive="active" routerLink="applicants"
                data-bs-dismiss="offcanvas" i18n>Applicants</a>
            </li>
            <li class="nav-item">
              <a title="Employees" class="nav-link" routerLinkActive="active" routerLink="employees"
                data-bs-dismiss="offcanvas" i18n>Partners</a>
            </li>
            <li class="nav-item">
              <a title="Customers" class="nav-link" routerLinkActive="active" routerLink="customers"
                data-bs-dismiss="offcanvas" i18n>Customers</a>
            </li>
            <li class="nav-item">
              <a title="Work shifts" class="nav-link" routerLinkActive="active" routerLink="shifts"
                data-bs-dismiss="offcanvas" i18n>Orders</a>
            </li>
            <li class="nav-item">
              <a title="Feedback" class="nav-link" routerLinkActive="active" routerLink="feedback"
                data-bs-dismiss="offcanvas" i18n>Feedback</a>
            </li>
            <li class="nav-item">
              <a title="Tasks" class="nav-link" routerLinkActive="active" routerLink="tasks" data-bs-toggle="collapse"
                data-bs-dismiss="offcanvas" i18n>Tasks</a>
            </li>
            <li class="nav-item">
              <a title="Messages" class="nav-link" routerLinkActive="active" routerLink="messages"
                data-bs-dismiss="offcanvas" i18n>Messages</a>
            </li>
            <li class="nav-item">
              <a title="Equipment" class="nav-link" routerLinkActive="active" routerLink="equipment"
                data-bs-dismiss="offcanvas" i18n>Equipment</a>
            </li>
            
            <li class="nav-item">
              <a *ngIf="currentUser.type != 'partner'" title="Partners" class="nav-link" routerLinkActive="active"
                routerLink="partners" data-bs-dismiss="offcanvas" i18n>Partners</a>
            </li>
            
            <li *ngIf="currentUser.type == 'administrator'" class="nav-item dropdown">
              <a title="Reporting" class="nav-link dropdown-toggle"
                [class.active]="router.isActive('/reporting', false)" data-bs-toggle="dropdown" href="#" role="button"
                aria-haspopup="true" aria-expanded="false" i18n>Reporting</a>
              <div class="dropdown-menu">
                <a title="Wok shift financials" class="dropdown-item" routerLink="reporting/shifts"
                  data-bs-dismiss="offcanvas" i18n>Work shift financials</a>
                <a title="Invoice report" class="dropdown-item" routerLink="reporting/invoice"
                  data-bs-dismiss="offcanvas" i18n>Invoice report</a>
                <a title="Salary report" class="dropdown-item" routerLink="reporting/salary" data-bs-dismiss="offcanvas"
                  i18n>Salary report</a>
                <a title="Profit report" class="dropdown-item" routerLink="reporting/profit" data-bs-dismiss="offcanvas"
                  i18n>Profit report</a>
                <a title="User report" class="dropdown-item" routerLink="reporting/user" data-bs-dismiss="offcanvas"
                  i18n>User report</a>
              </div>
            </li>
            <li *ngIf="currentUser.type == 'administrator'" class="nav-item dropdown">
              <a title="Export" class="nav-link dropdown-toggle" [class.active]="router.isActive('/export', false)"
                data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"
                i18n>Export</a>
              <div class="dropdown-menu">
                <a title="Customers" class="dropdown-item" routerLink="export/customers" data-bs-dismiss="offcanvas"
                  i18n>Customers</a>
                <a title="Employees" class="dropdown-item" routerLink="export/employees" data-bs-dismiss="offcanvas"
                  i18n>Employees</a>
                <a title="Invoices" class="dropdown-item" routerLink="export/invoices" data-bs-dismiss="offcanvas"
                  i18n>Invoices</a>
                <a title="Salaries" class="dropdown-item" routerLink="export/salaries" data-bs-dismiss="offcanvas"
                  i18n>Salaries</a>
                <a title="Subcontractor invoices" class="dropdown-item" routerLink="export/subcontractor-invoices"
                  data-bs-dismiss="offcanvas" i18n>Subcontractor invoices</a>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a title="Settings" class="nav-link dropdown-toggle" [class.active]="router.isActive('/settings', false)"
                data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"
                i18n>Settings</a>
              <div class="dropdown-menu">


                <a *ngIf="currentUser.type == 'administrator'" title="Organization settings" class="dropdown-item"
                  routerLink="settings/organization/general" data-bs-dismiss="offcanvas" i18n>Organization settings</a>
                <a *ngIf="currentUser.type == 'administrator'" title="Products anc services" class="dropdown-item"
                  routerLink="settings/products" data-bs-dismiss="offcanvas" i18n>Products and services</a>
                <a *ngIf="currentUser.type == 'administrator'" title="Back office users" class="dropdown-item"
                  routerLink="settings/users" data-bs-dismiss="offcanvas" i18n>Back office users</a>
            <li *ngIf="currentUser.type == 'administrator'">
              <hr class="dropdown-divider">
            </li>
            <a title="Personal settings" class="dropdown-item" routerLink="profile" data-bs-dismiss="offcanvas"
              i18n>Personal settings</a>
            <li *ngIf="currentUser.type == 'administrator'">
              <hr class="dropdown-divider">
            </li>
            <a *ngIf="currentUser.type == 'administrator'" title="Check translations" class="dropdown-item"
              routerLink="settings/translations" data-bs-dismiss="offcanvas" i18n>Check translations</a>
            <a *ngIf="currentUser.type == 'administrator'" title="Import data" class="dropdown-item"
              routerLink="settings/import" ddata-bs-dismiss="offcanvas" i18n>Import data</a>
            <li>
              <hr class="dropdown-divider">
            </li>
            <a *ngIf="currentUser.type == 'administrator'" title="Accounting partners" class="dropdown-item"
              routerLink="settings/accounting" data-bs-dismiss="offcanvas" i18n>Accounting products</a>
            <li>
              <hr class="dropdown-divider">
            </li>
            <a title="Legal" class="dropdown-item" routerLink="settings/legal" data-bs-dismiss="offcanvas"
              i18n>Legal</a>
        </div>
        </li>
        -->
        <li class="nav-item d-xl-none">

        </li>
        <li class="nav-item d-xl-none">
          <a title="Manual" class="nav-link" [href]="'/manual/' + locale" target="_blank" i18n>Manual</a>
        </li>
        <li class="nav-item d-xl-none">
          <a title="Logout" class="nav-link" routerLink="logout" i18n>Logout</a>
        </li>
        <li class="nav-item dropdown d-xl-none">
          <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown">
            <fa-icon style="font-size: 1.3rem; color: white" [icon]="fa.faGlobe"></fa-icon>
          </a>
          <div class="dropdown-menu dropdown-menu-end">
            <button *ngFor="let locale of environment.locales" type="button" class="dropdown-item"
              (click)="changeLanguage(locale)">{{ locale| i18nSelect: locales }}</button>
          </div>
        </li>
        </ul>

        <span class="ms-auto d-none d-xl-inline">
          <ul class="navbar-nav d-inline-block">
            <li class="nav-item dropdown">
              <a title="Change language" i18n-title class="nav-link" style="font-size: 1.3rem;"
                data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"><fa-icon
                  [icon]="fa.faGlobe"></fa-icon></a>
              <div class="dropdown-menu dropdown-menu-end">
                <button *ngFor="let locale of environment.locales" type="button" class="dropdown-item"
                  (click)="changeLanguage(locale)">{{ locale| i18nSelect: locales }}</button>
              </div>
            </li>
          </ul>

          <ul class="navbar-nav d-inline-block">
            <li class="nav-item">
              <a title="Logout" i18n-title class="nav-link" style="font-size: 1.3rem;" routerLink="logout"><fa-icon
                  [icon]="fa.faRightFromBracket"></fa-icon></a>
            </li>
          </ul>
        </span>
      </div>
    </div>
  </div>
  </div>
</nav>
<div style="position: fixed; right: 0.5rem; top: 0.5rem; z-index: 1000;">
  <div *ngIf="(messages.length + toasts.length) > 1" class="text-end"><button (click)="clearToasts()" type="button"
      class="btn btn-sm btn-secondary" i18n>Clear all</button></div>
  <ngb-toast *ngFor="let message of messages"
    [header]="message.from_employee_id ? (message.from_employee.first_name + ' ' + message.from_employee.last_name) : (message.from_contact.first_name + ' ' + message.from_contact.last_name) + (message.created_at | date: 'short')"
    [autohide]="false" [delay]="5000" (hidden)="removeMessage(message)">
    <span style="white-space: pre-wrap;">{{ message.message }}</span>
    <div class="mt-1">
      <a *ngIf="message.from_employee_id" [routerLink]="['/employees', message.from_employee_id]" fragment="messages"
        (click)="removeMessage(message)">View messages</a>
      <a *ngIf="message.from_contact_id" [routerLink]="['/customers', 'contacts', message.from_contact_id]"
        fragment="messages">View messages</a>
    </div>
  </ngb-toast>

  <ngb-toast *ngFor="let toast of toasts"
    [header]="(toast.type | i18nSelect: notificationTypes) + ' ' + (toast.time | date: 'short')" [autohide]="false"
    [delay]="5000" (hidden)="removeToast(toast)">
    <p *ngIf="toast.shift">{{ toast.shift.start | date: 'EE' }} {{ toast.shift.start | date: 'short' }} {{
      toast.shift.customer.name }} {{ toast.shift.assignment | translateField: 'name' }}</p>
    <p *ngIf="toast.applicant">{{ toast.applicant.first_name }} {{ toast.applicant.last_name }}</p>
    <p *ngIf="toast.task && toast.task.created_by_customer_contact_id">{{
      toast.task.created_by_customer_contact.first_name }} {{ toast.task.created_by_customer_contact.last_name }}</p>
    <p *ngIf="toast.task && toast.task.created_by_employee_id">{{ toast.task.created_by_employee.first_name }} {{
      toast.task.created_by_employee.last_name }}</p>
    <p *ngIf="toast.payment">{{ toast.payment.amount }} {{ toast.payment.currency }} {{
      toast.payment.customer_contact.first_name }} {{
      toast.payment.customer_contact.last_name }}</p>
    <p *ngIf="toast.contact">{{ toast.contact.first_name }} {{ toast.contact.last_name }}</p>
    <div class="mt-1">
      <a *ngIf="toast.shift" [routerLink]="['/shifts', toast.shift.id]" (click)="removeToast(toast)">View work shift</a>
      <a *ngIf="toast.applicant" [routerLink]="['/applicants', toast.applicant.id]" (click)="removeToast(toast)">View
        applicant</a>
      <a *ngIf="toast.task" [routerLink]="['/tasks', toast.task.id]" (click)="removeToast(toast)">View task</a>
      <a *ngIf="toast.payment" [routerLink]="['/customers', 'contacts', toast.payment.customer_contact_id]"
        fragment="payments" (click)="removeToast(toast)">View payment</a>
      <a *ngIf="toast.contact" [routerLink]="['/customers', 'contacts', toast.contact.id]"
        (click)="removeToast(toast)">View customer personnel</a>
    </div>
  </ngb-toast>
</div>
<div class="container-fluid" style="margin-top: 1rem;">
  <router-outlet></router-outlet>
</div>